import React from 'react';
import { useSelector } from 'react-redux';

import { useOnMountDataRequest } from 'common/hooks';

import FadeInTransition from 'common/components/FadeInTransition';
import Layout from 'common/components/Layout';
import LoadingPage from 'common/components/LoadingPage';

import {
  webhooks as webhooksSelector,
  isFetchingWebhooks as isFetchingWebhooksSelector,
} from '../reducers';
import actions from '../actions';

import IntegrationsTabs from '../components/IntegrationsTabs';
import WebhooksTable from '../components/WebhooksTable';

const useWebhooksData = () => {
  const { isMounting } = useOnMountDataRequest(actions.webhooksRequest);
  const webhooks = useSelector(webhooksSelector);
  const isFetchingWebhooks = useSelector(isFetchingWebhooksSelector);

  return {
    webhooks,
    isFetching: isMounting || isFetchingWebhooks,
  };
};

const WebhooksContainer = () => {
  const { webhooks, isFetching } = useWebhooksData();

  return (
    <Layout heading="Integrations">
      <IntegrationsTabs />
      {isFetching && <LoadingPage />}
      {!isFetching && (
        <FadeInTransition>
          <WebhooksTable webhooks={webhooks} />
        </FadeInTransition>
      )}
    </Layout>
  );
};

export default WebhooksContainer;
